import Icon from '../components/Icon.vue'

Icon.register({
  'user-circle': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 104c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zM248 448c58.7 0 111.3-26.6 146.5-68.2-18.8-35.4-55.6-59.8-98.5-59.8-2.4 0-4.8 0.4-7.1 1.1-12.9 4.2-26.6 6.9-40.9 6.9s-27.9-2.7-40.9-6.9c-2.3-0.7-4.7-1.1-7.1-1.1-42.9 0-79.7 24.4-98.5 59.8 35.2 41.6 87.8 68.2 146.5 68.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-circle.js
// module id = 2058
// module chunks = 0